<!-- 517394 color -->
<template>
<div class="wrapper">
  <!-- <nav>
    <ul>
      <li>HOME</li>
      <li>ABOUT</li>
    </ul>
  </nav> -->

  <div class="content">
    <div>
      <h1>KESHI <small><a href="https://www.storyboard.gg/" style="color: #F8BB3E; text-decoration: none;" target="_blank">STORYBOARD</a></small></h1>

      <div v-if="instagram">
        <p>click on the 3 buttons in the top right corner, and press "open in safari"</p>

      </div>

      <div v-if="!instagram && !password">
        <br><br>
        <p v-if="this.pwd_error" style="color: red">{{this.pwd_error}}</p>
        <input maxlength="13" type="" name="" v-model="pwd" placeholder="password">
        <button style="width: 100%;" v-on:click="submitPass()" class="btn btn-fill">SUBMIT</button>
      </div>

      <div v-if="!instagram && !auth && password">
        <p>Welcome to the campground.</p>
        <br /><br />
        <button v-on:click="authSpotify()" class="btn">SPOTIFY</button>
        <button v-on:click="authApple()" class="btn">APPLE</button>
      </div>

      <div v-if="!instagram && auth && password && countdown_str">
        <p style="font-size: 2rem">See you in {{countdown_str}}</p>
      </div>

      <div v-if="!instagram && auth && password && !countdown_str">
        <p>What's your name?</p>
        <br><br>
        <p v-if="this.error" style="color: red">{{this.error}}</p>
        <input @keydown="keydown" maxlength="13" type="" name="" v-model="name" placeholder="username">
        <button style="width: 100%;" v-on:click="setName()" class="btn btn-fill">SUBMIT</button>
      </div>
    </div>

    <div>
      <!-- <img style="height: 500px; opacity: .3; filter: blur(2px)" src="https://cdn130.picsart.com/297052415052211.png?type=webp&to=min&r=240"> -->
    </div>
  </div>

  <div class="terms">
    <ul>
      <li><a href="https://privacy.umusic.com/terms/" target="_blank">terms</a></li>
      <li><a href="https://privacy.umusic.com/" target="_blank">privacy</a></li>
    </ul>
  </div>

  <div class="socials">
    <ul>
      <li><a href="https://www.storyboard.gg/" target="_blank">storyboard</a></li>
      <li><a href="https://twitter.com/keshimusic" target="_blank">twitter</a></li>
      <li><a href="https://www.instagram.com/keshi/" target="_blank">instagram</a></li>
    </ul>
  </div>
</div>
</template>

<script>
import store from '../store';
let popup;

export default {
  name: 'Landing',
  data: function() {
    return {
      storeState: store.state,
      auth: false,
      password: false,
      pwd: '',
      error: '',
      pwd_error: '',
      name: '',
      // startTime: 1603425600,
      countdown_str: '',
      instagram: navigator.userAgent.toLowerCase().indexOf('instagram') > -1,

      countdown_interval: null
    }
  },
  props: {
    // authorizeU
  },
  methods: {
    async submitPass() {
      if(!this.pwd || this.pwd.toLowerCase() !== 'xoxosos')
        return this.pwd_error = 'Incorrect password.'

      this.password = true;
    },
    async authSpotify() {
      popup = window.open(
        `${this.storeState.API_URL}/oauth/spotify`,
        'Login with Spotify',
        'width=800,height=600'
      )
    },
    async authApple() {
      let authorized = await this.storeState.apple_player.authorize();
      // fetch(`/apple-callback?token=${authorized}`);


      this.auth = true;
      // store.setView(2);
    },
    keydown(e) {
      if(e.which === 13) this.setName();
    },
    setName() {
      if(!this.name)
        return this.error = 'Please enter your username to continue.'

      if(!/^[a-zA-Z0-9]*$/.test(this.name))
        return this.error = 'Only alpha numeric characters';

      if(this.name.length > 13)
        return this.error = 'Must be less than 13 characters';

      store.setName(this.name);
      store.setView(2);
    },

    countdown() {
      let self = this;
      this.countdown_interval = setInterval(function() {
          // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = self.storeState.START_TIME - now;

        if (distance <= 0) {
          self.countdown_str = null;
          return clearInterval(self.countdown_interval);
        }

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"

        self.countdown_str = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
      }.bind(this), 1000);
    }
  },
  async created() {
    let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;

    let res = await fetch(`${this.storeState.API_URL}/handshake?ns=${subdomain}`)
      , data = await res.json();

    let {apple_token,start_time,tracks} = data;

    registerApple(apple_token);
    addScript('https://js-cdn.music.apple.com/musickit/v1/musickit.js');

    store.setTracks(tracks);
    // store.setStartTime(start_time);
    start_time = Date.now() + parseInt(data.start_time);
    store.setStartTime(start_time)

    this.countdown()
    window.addEventListener('message', handleMessage.bind(this), false);
  }
}

  /*
 * apple
 */
function registerApple(token) {
  document.addEventListener('musickitloaded', function() {
    MusicKit.configure({
      developerToken: token,
      app: {
        name: 'love is not dying - listening party',
        build: '0.5'
      }
    });

    store.setApplePlayer(MusicKit.getInstance());
  });
}

/**
 * handle spotify message
 */
function handleMessage(e) {
   // if (e.origin !== store.state.API_URL)
   //  return;

  let data;
  try {
    data = JSON.parse(e.data);
  } catch(err) {
    return;
  }

  if(!data.access_token) return;

  popup.close();

  /**
   * UPDATE APP STORE
   */
  store.setAccessToken(data.access_token);
  store.setSpotifyPremium(data.premium)

  let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
  // fetch endpoint 
  fetch(`${this.storeState.API_URL}/sp-gate`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      ns: subdomain,
      access_token: data.access_token
    })
  })


  // initSpotifyWebPlayback(data.access_token);
  // addScript('https://sdk.scdn.co/spotify-player.js');

  /**
   * Move to label name scene
   */
  // store.setView(2);
  this.auth = true;

}

function initSpotifyWebPlayback(oauth_token, onPlayerReady) {
  window.onSpotifyWebPlaybackSDKReady = () => {
    const token = oauth_token;

    let spotify_player = new Spotify.Player({
      name: 'love is not dying - listening experience',
      getOAuthToken: cb => { cb(token); }
    });

    // Error handling
    spotify_player.addListener('initialization_error', ({ message }) => { console.error(message); });
    spotify_player.addListener('authentication_error', ({ message }) => { console.error(message); });
    spotify_player.addListener('account_error', ({ message }) => { console.error(message); });
    spotify_player.addListener('playback_error', ({ message }) => { console.error(message); });

    // Playback status updates
    // spotify_player.addListener('player_state_changed', state => { console.log('SPOTIFY STATE',state); });

    // Ready
    spotify_player.addListener('ready', ({ device_id }) => {
      // onPlayerReady(spotify_player);
      store.setSpotifyPlayer(spotify_player);
    });

    // Not Ready
    spotify_player.addListener('not_ready', ({ device_id }) => {
      console.log('Device ID has gone offline', device_id);
    });

    // Connect to the player!
    spotify_player.connect()
    .then(() => console.log('sp.'+Math.random().toString().substring(0,36)));
  };
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Rowdies:wght@300;400;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@200;300,400;700&display=swap');

  * {
    margin: 0;
    border: 0;
    padding: 0;
    font-weight: 200;
    font-family: 'Raleway', sans-serif;
  }

  .wrapper {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;

    height: 100%;
    height: -webkit-fill-available;
    min-width: 100vw;
  }

  nav {
    position: absolute;
    top: 46px;
    right: 46px;
  }

  nav ul {
    padding: 0;
    margin: 0;
  }
  nav ul li {
    display: inline;
  }

  small {
    font-size: 30px;
  }

  .terms {
    position: absolute;
    bottom: 46px;
    left: 46px;
  }

  .terms ul li {
    display: inline;
    margin-right: 1rem;
  }

  .terms ul li a {
    color: #F8BB3E;
    text-decoration: none;
  }

  .socials {
    position: absolute;
    bottom: 46px;
    right: 46px;
  }

  .socials ul li {
    display: inline;
    margin-left: 1rem;
  }

  .socials ul li a {
    color: #F8BB3E;
    text-decoration: none;
  }

  .content {
    margin: 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content h1 {
    font-size: 50px;
    font-family: 'Rowdies', cursive;
  }

  .content p {
    font-size: 18px;
    font-weight: 200;
    font-family: 'Raleway', sans-serif;
  }

  button {
    background: none;
    color: #F8BB3E;
    border: 4px solid #F8BB3E;
    padding: .5rem 1.2rem;
    font-size: 16px;
    font-weight: 700;
    margin-right: 1rem;
    font-family: 'Rowdies', cursive;
    cursor: pointer;
  }

  button:hover {
    background-color: #F8BB3E;
    color: #000;
  }

  input {
    box-sizing: border-box;
    display: block;
    outline: none;
    width: 100%;
    margin-bottom: .6rem;
    padding: 10px;
    font-size: 16px;
    color: #fff;
    background: rgba(140, 166, 192, .5);
  }

  @media screen and (max-width: 800px) {
    .content {
      margin: 2.5rem;
    }

    .socials, .terms {
      font-size: 14px;
    }

    .socials {
      right: 2.5rem;
    }

    .terms {
      left: 2.5rem;
    }
  }

  @media screen and (max-width: 400px) {
    .content {
      margin: 2rem;
    }

    .socials, .terms {
      font-size: 12px;
    }

    .socials {
      right: 2rem;
    }

    .terms {
      left: 2rem;
    }
  }
</style>
